import { useFormikContext } from 'formik';
import React, { FunctionComponent, useEffect } from 'react';
import { ibanMask } from '../../services/common/validation';
import { useValidateIbanMutation } from '../../services/redux/features/api/ibanValidator.api-slice';
import { TextInputFormField, TextInputFormFieldProps } from './TextInputFormField';

interface IbanFormFieldProps extends Omit<TextInputFormFieldProps, 'mask'> {
  updateBic?: boolean;
}

export const IbanFormField: FunctionComponent<IbanFormFieldProps> = ({ updateBic = false, ...props }) => {
  const { setFieldValue } = useFormikContext<unknown>();
  const [validateIban, { data }] = useValidateIbanMutation();

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (props.onBlur) {
      props.onBlur(e);
    }

    if (value && value.length >= 10 && value.length <= 40) {
      validateIban({ iban: value });
    }
  };

  useEffect(() => {
    if (data?.isValid && data.paymentData?.bic && updateBic) {
      setFieldValue('bic', data.paymentData.bic);
    }
  }, [data, updateBic, setFieldValue]);

  return <TextInputFormField {...props} mask={ibanMask} onBlur={handleBlur} />;
};
